 /**
 * Created by sarimz on 6/20/17.
 */
// Libraries
import React from 'react';
import PropTypes from 'prop-types';
import config from 'config';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';

import * as HeaderActions from '@getgo/webinar.com-frontend-redux/lib/shared/actions/header';
import * as FooterActions from '@getgo/webinar.com-frontend-redux/lib/shared/actions/footer';
import PageTracker from 'app-lib/helpers/page-tracker';
import Page from 'src/model/page';

export class UnsupportedBrowser extends React.Component {

    constructor(props) {
        super(props);
    }

    componentDidMount() {
        this.setHeader();
        PageTracker.lastPage = Page.UNSUPPORTED_BROWSER;
    }

    componentWillUnmount() {
        this.props.initHeader();
    }

    setHeader() {
        const self = this;
        self.props.initHeader({
            navbarBackgroundClasses: 'error-page-header-nav-bar',
            menuItemTextClasses: 'error-page-header-menu-item-text',
            showAlternateLogo: true
        });
        self.props.initFooter();
    }

    browserLinks() {
        const {t} = this.props;
        return (
            <div className="row">
                <div className="col-md-2">
                    <a href="https://www.google.com/chrome/browser/desktop/index.html" target="_blank" rel="noopener">
                        <img src={`${config.assets.url}/images/browsers/chrome.png`} alt="chrome logo" />
                    </a>
                    <div>{t('unsupportedBrowser.chrome')}</div>
                </div>
                <div className="col-md-2">
                    <a href="https://www.mozilla.org/en-US/firefox/" target="_blank" rel="noopener">
                        <img src={`${config.assets.url}/images/browsers/FF.png`} alt="firefox logo" />
                    </a>
                    <div>{t('unsupportedBrowser.firefox')}</div></div>
                <div className="col-md-2">
                    <a href="https://www.microsoft.com/en-us/download/internet-explorer.aspx" target="_blank" rel="noopener">
                        <img src={`${config.assets.url}/images/browsers/IE.png`} alt="internet explorer logo" />
                    </a>
                    <div>{t('unsupportedBrowser.ie')}</div>
                </div>
                <div className="col-md-2">
                    <a href="https://www.microsoft.com/en-us/windows/microsoft-edge" target="_blank" rel="noopener">
                        <img src={`${config.assets.url}/images/browsers/ME.png`} alt="edge logo" />
                    </a>
                    <div>{t('unsupportedBrowser.me')}</div>
                </div>
                <div className="col-md-2">
                    <a href="https://support.apple.com/downloads/safari" target="_blank" rel="noopener">
                        <img src={`${config.assets.url}/images/browsers/safari.png`} alt="safari logo" />
                    </a>
                    <div>{t('unsupportedBrowser.safari')}</div>
                </div>
            </div>
        );
    }

    render() {
        const {t} = this.props;
        return (
            <div className="unsupported-browser">
                <div className="unsupported-browser__content-head">{t('unsupportedBrowser.unsupported')}</div>
                <div className="unsupported-browser__content-description">{t('unsupportedBrowser.description')}</div>
                <div className="unsupported-browser__content-instruction">{t('unsupportedBrowser.download')}</div>
                {this.browserLinks()}
            </div>
        );
    }
}

UnsupportedBrowser.propTypes = {
    t: PropTypes.func,
    initHeader: PropTypes.func,
    initFooter: PropTypes.func
};

export default connect(
    null,
    dispatch => bindActionCreators(Object.assign({}, HeaderActions, FooterActions), dispatch)
)(translate(['translation'])(UnsupportedBrowser));



// WEBPACK FOOTER //
// ./src/components/errors/unsupported-browser.js